import * as actions from '~/actions/formActions/embeddedBarcode';

import {createReducer} from '~/helpers/reduxHelper';


const initialState = {
  initialValues: null,
  type: 0,
  enabled: false,
  decimalPoints: 0,
  editMode: false,
  changed: false,
  enableSubmit: false,
};

const actionHandlers = {
  [actions.SHOW_EMBEDDED_BARCODE_SETTING]: (state, action) => {
    const { store, scale_barcodes } = action;
    return ({
      initialValues: store,
      type: store.embedded_barcode_type,
      enabled: store.embedded_barcode_enabled,
      decimalPoints: store.embedded_barcode_decimal_points,
      editMode: false,
      changed: false,
      enableSubmit: false,
      scale_barcodes
    });
  },
  [actions.SHOW_SCALE_BARCODE_NUMBER]: (state, action) => {
    const { scale_barcodes } = action;
    return Object.assign({}, state, { scale_barcodes });
  },
  [actions.EDIT_SCALE_BARCODE]: (state, action) => {
    const { value, order } = action;
    const { scale_barcodes } = state
    scale_barcodes[order].prefix = value
    return Object.assign({}, state, { scale_barcodes:[...scale_barcodes] });
  },
  //add with decimal
  [actions.EDIT_SCALE_BARCODE_DECIMAL]: (state, action) => {
    const { value, order } = action;
    const { scale_barcodes } = state
    scale_barcodes[order].decimal = value
    return Object.assign({}, state, { scale_barcodes:[...scale_barcodes] });
  },
  //vaild with prefix
  [actions.VALID_SCALEPREFIX]: (state, action) => {
    const { scale_barcodes } = state
    return Object.assign({}, state, { scale_barcodes:[...scale_barcodes] });
  },
  [actions.CHANGE_EMBEDDED_BARCODE_ENABLED]: (state, action) => {
    const { value } = action;
    const { type, decimalPoints, initialValues, scale_barcodes } = state;
    const { embedded_barcode_enabled, embedded_barcode_decimal_points, embedded_barcode_type } = initialValues;
    let changed = value !== embedded_barcode_enabled || type !== embedded_barcode_type || decimalPoints !== embedded_barcode_decimal_points;
    return Object.assign({}, state, { enabled: value, changed });
  },
  [actions.CHANGE_EMBEDDED_BARCODE_TYPE]: (state, action) => {
    const { value } = action;
    const { enabled, initialValues, scale_barcodes} = state;
    const { embedded_barcode_enabled, embedded_barcode_decimal_points, embedded_barcode_type } = initialValues;
    let changed = enabled !== embedded_barcode_enabled || value !== embedded_barcode_type || 0 !== embedded_barcode_decimal_points;
    return Object.assign({}, state, { type: value, decimalPoints: 0, changed });
  },
  [actions.CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS]: (state, action) => {
    const { value, order } = action;
    const { enabled, type, initialValues, scale_barcodes} = state;
    const obj =Object.assign({}, scale_barcodes[order])
    const {decimal} = obj
    scale_barcodes[order].decimal = value
    const { embedded_barcode_enabled, embedded_barcode_decimal_points, embedded_barcode_type } = initialValues;
    let changed = enabled !== embedded_barcode_enabled || type !== embedded_barcode_type || value !== decimal;
    return Object.assign({}, state, { decimalPoints: value, changed, scale_barcodes:[...scale_barcodes] });
  },
  [actions.EDIT_EMBEDDED_BARCODE_SETTING]: (state, action) => {
    return Object.assign({}, state, { editMode: true, enableSubmit: true });
  },
  [actions.DISCARD_EMBEDDED_BARCODE_SETTING]: (state, action) => {
    const { initialValues } = state;
    return Object.assign({}, state, {
      type: initialValues.embedded_barcode_type,
      enabled: initialValues.embedded_barcode_enabled,
      decimalPoints: initialValues.embedded_barcode_decimal_points,
      editMode: false,
      changed: false,
      enableSubmit: false
    });
  },
  [actions.SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST]: (state, action) => {
    return Object.assign({}, state, { enableSubmit: false });
  },
  [actions.SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS]: (state, action) => {
    return Object.assign({}, state, { enableSubmit: true, editMode: false });
  },
  [actions.SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE]: (state, action) => {
    return Object.assign({}, state, { enableSubmit: true, editMode: false });
  },
};

export default createReducer(initialState, actionHandlers);



/** WEBPACK FOOTER **
 ** ./client/store/reducers/formsReducer/embeddedBarcodeReducer.js
 **/